import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { nanoid } from "@reduxjs/toolkit";
import { getFullUrlPath } from "./HandleFileFunction";
import { getSupplierProductName } from "./HelperProduct";
import moment from "moment";
import { getVatByMstCategoryPrice } from "./HelperFunction";
// private
var pipelineStepsFromDoID = [
    mappingLoadByDoID,
    mappingDoItem,
    mappingDoMember
];
var pipelineStepsFromSoDoc = [
    mappingSoItemForDo,
    mappingLoadDocFromSoData
];
function mappingSoItemForDo(param) {
    var setProductRow = param.setProductRow, dataWithReplacements = param.dataWithReplacements;
    if (dataWithReplacements.factNewSoItem && dataWithReplacements.factNewSoItem.length > 0) {
        var productItems = dataWithReplacements.factNewSoItem.map(function(v) {
            var _dimProductPrice_dimProduct, _dimProductPrice_dimProduct1, _dimProductPrice_dimProduct2, _dimProductPrice_dimProduct3;
            var id = v.id, dim_product_price_id = v.dim_product_price_id, quantity = v.quantity, unit_price = v.unit_price, unit_id = v.unit_id, ratio_unit = v.ratio_unit, container = v.container, dim_mst_discount_type_id = v.dim_mst_discount_type_id, remark = v.remark, discount_value = v.discount_value, discount_price = v.discount_price, dimWarehouse = v.dimWarehouse, dimProductPrice = v.dimProductPrice, dimMasterUnit = v.dimMasterUnit, dimMstVat = v.dimMstVat, dimNewPoSplitItem = v.dimNewPoSplitItem, remaining_quantity = v.remaining_quantity, delivered_quantity = v.delivered_quantity;
            // console.log(discount_price);
            var finalRemainingQty = delivered_quantity === 0 && remaining_quantity === 0 ? quantity : remaining_quantity;
            var mappingData = {
                rowID: nanoid(),
                soItemID: id,
                item_so_quantity: quantity,
                deliveredQty: delivered_quantity,
                remainingQty: finalRemainingQty,
                productID: dim_product_price_id,
                productCode: (_dimProductPrice_dimProduct = dimProductPrice.dimProduct) === null || _dimProductPrice_dimProduct === void 0 ? void 0 : _dimProductPrice_dimProduct.sku,
                productName: (_dimProductPrice_dimProduct1 = dimProductPrice.dimProduct) === null || _dimProductPrice_dimProduct1 === void 0 ? void 0 : _dimProductPrice_dimProduct1.name_th,
                productBarcode: dimProductPrice.barcode,
                productUnitID: unit_id,
                productRatioUnit: ratio_unit,
                productContainer: container,
                supplierCode: (_dimProductPrice_dimProduct2 = dimProductPrice.dimProduct) === null || _dimProductPrice_dimProduct2 === void 0 ? void 0 : _dimProductPrice_dimProduct2.supplier_code,
                supplierName: getSupplierProductName((_dimProductPrice_dimProduct3 = dimProductPrice.dimProduct) === null || _dimProductPrice_dimProduct3 === void 0 ? void 0 : _dimProductPrice_dimProduct3.supplier_names),
                warehouseID: dimWarehouse.id,
                warehouseName: dimWarehouse.name,
                productUnit: dimMasterUnit ? dimMasterUnit.name : "-",
                productQty: finalRemainingQty,
                productOrdered: dimNewPoSplitItem ? dimNewPoSplitItem.total_received_quantity : 0,
                ums: "",
                productStock: "",
                productPrice: unit_price,
                discountType: dim_mst_discount_type_id,
                discount: discount_price,
                discountPercent: discount_value,
                tax: "",
                price_before_tax: 0,
                dim_mst_vat_id: dimMstVat.id,
                vat: dimMstVat.value,
                note: remark,
                price_after_tax: 0,
                not_approve_reason: "",
                is_checked: false,
                edit: false
            };
            return mappingData;
        });
        dataWithReplacements.products = productItems;
        setProductRow(productItems);
    }
}
function mappingDoItem(param) {
    var setProductRow = param.setProductRow, dataWithReplacements = param.dataWithReplacements;
    if (dataWithReplacements.factNewDoItem && dataWithReplacements.factNewDoItem.length > 0) {
        var productItems = dataWithReplacements.factNewDoItem.map(function(v) {
            var _dimProductPrice_dimProduct, _dimProductPrice_dimProduct1, _dimProductPrice_dimProduct2, _dimProductPrice_dimProduct3;
            var id = v.id, fact_new_so_item_id = v.fact_new_so_item_id, dim_product_price_id = v.dim_product_price_id, quantity = v.quantity, unit_price = v.unit_price, unit_id = v.unit_id, ratio_unit = v.ratio_unit, container = v.container, dim_mst_discount_type_id = v.dim_mst_discount_type_id, remark = v.remark, discount_value = v.discount_value, discount_price = v.discount_price, dimWarehouse = v.dimWarehouse, dimProductPrice = v.dimProductPrice, dimMasterUnit = v.dimMasterUnit, dimMstVat = v.dimMstVat, item_so_quantity = v.item_so_quantity, delivered_quantity = v.delivered_quantity, remaining_quantity = v.remaining_quantity;
            // console.log(discount_price);
            var finalRemainingQty = delivered_quantity === 0 && remaining_quantity === 0 ? item_so_quantity : remaining_quantity;
            var mappingData = {
                rowID: nanoid(),
                doItemID: id,
                soItemID: fact_new_so_item_id,
                deliveredQty: delivered_quantity,
                remainingQty: finalRemainingQty,
                productID: dim_product_price_id,
                item_so_quantity: item_so_quantity,
                productCode: (_dimProductPrice_dimProduct = dimProductPrice.dimProduct) === null || _dimProductPrice_dimProduct === void 0 ? void 0 : _dimProductPrice_dimProduct.sku,
                productName: (_dimProductPrice_dimProduct1 = dimProductPrice.dimProduct) === null || _dimProductPrice_dimProduct1 === void 0 ? void 0 : _dimProductPrice_dimProduct1.name_th,
                productBarcode: dimProductPrice.barcode,
                productUnitID: unit_id,
                productRatioUnit: ratio_unit,
                productContainer: container,
                supplierCode: (_dimProductPrice_dimProduct2 = dimProductPrice.dimProduct) === null || _dimProductPrice_dimProduct2 === void 0 ? void 0 : _dimProductPrice_dimProduct2.supplier_code,
                supplierName: getSupplierProductName((_dimProductPrice_dimProduct3 = dimProductPrice.dimProduct) === null || _dimProductPrice_dimProduct3 === void 0 ? void 0 : _dimProductPrice_dimProduct3.supplier_names),
                warehouseID: dimWarehouse.id,
                warehouseName: dimWarehouse.name,
                productUnit: dimMasterUnit ? dimMasterUnit.name : "-",
                productQty: quantity,
                productOrdered: 0,
                ums: "",
                productStock: "",
                productPrice: unit_price,
                discountType: dim_mst_discount_type_id,
                discount: discount_price,
                discountPercent: discount_value,
                tax: "",
                price_before_tax: 0,
                dim_mst_vat_id: dimMstVat.id,
                vat: dimMstVat.value,
                note: remark,
                price_after_tax: 0,
                not_approve_reason: "",
                is_checked: false,
                edit: false
            };
            return mappingData;
        });
        dataWithReplacements.products = productItems;
        setProductRow(productItems);
    }
}
function mappingDoMember(param) {
    var setPdata = param.setPdata, dataWithReplacements = param.dataWithReplacements;
    if (dataWithReplacements.factMember) {
        var _dataWithReplacements_factMember = dataWithReplacements.factMember, id = _dataWithReplacements_factMember.id, customer_id = _dataWithReplacements_factMember.customer_id;
        var full_member_name = dataWithReplacements.full_member_name, full_member_address_name = dataWithReplacements.full_member_address_name, additional_info = dataWithReplacements.additional_info, member_branch_no = dataWithReplacements.member_branch_no, member_phone_number = dataWithReplacements.member_phone_number;
        setPdata(mappingMemberDo({
            id: id,
            customer_id: customer_id,
            full_member_name: full_member_name,
            full_member_address_name: full_member_address_name,
            additional_info: additional_info,
            member_branch_no: member_branch_no,
            member_phone_number: member_phone_number
        }));
    }
}
function mappingLoadDocFromSoData(param) {
    var setFormdata = param.setFormdata, setPdata = param.setPdata, dataWithReplacements = param.dataWithReplacements;
    mappingDoMember({
        dataWithReplacements: dataWithReplacements,
        setPdata: setPdata
    });
    setFormdata(function(prev) {
        var doc_number = prev.doc_number, dimMstDoStatus = prev.dimMstDoStatus, dim_mst_do_status_id = prev.dim_mst_do_status_id, refer = prev.refer, not_approve_reason = prev.not_approve_reason, updated_approve_at = prev.updated_approve_at, updated_wait_approve_at = prev.updated_wait_approve_at, canceled_at = prev.canceled_at, canceled_by_emp_id = prev.canceled_by_emp_id, is_sort_manual = prev.is_sort_manual, createdNewDoEmp = prev.createdNewDoEmp, doc_issue_date = prev.doc_issue_date, delivery_date = prev.delivery_date;
        return _object_spread_props(_object_spread({}, dataWithReplacements), {
            createdNewDoEmp: createdNewDoEmp,
            doc_number: doc_number,
            dimMstDoStatus: dimMstDoStatus,
            dim_mst_do_status_id: dim_mst_do_status_id,
            refer: refer,
            is_sort_manual: is_sort_manual,
            not_approve_reason: not_approve_reason,
            updated_approve_at: updated_approve_at,
            updated_wait_approve_at: updated_wait_approve_at,
            canceled_at: canceled_at,
            canceled_by_emp_id: canceled_by_emp_id,
            doc_issue_date: doc_issue_date,
            delivery_date: delivery_date,
            so_doc_number_ref: dataWithReplacements.doc_number,
            fact_new_so_id: dataWithReplacements.id,
            sum_item_so_quantity: dataWithReplacements.sum_item_quantity
        });
    });
}
function mappingLoadByDoID(param) {
    var setFormdisabled = param.setFormdisabled, columnsort = param.columnsort, setColumnsort = param.setColumnsort, setAttachments = param.setAttachments, setAttachmentDeliver = param.setAttachmentDeliver, setTagSelected = param.setTagSelected, dataWithReplacements = param.dataWithReplacements;
    setAttachmentDeliver([]);
    if (dataWithReplacements.factDocFileDo && dataWithReplacements.factDocFileDo.length > 0) {
        var attchments = dataWithReplacements.factDocFileDo.map(function(v, i) {
            var newId = nanoid();
            var type = v.original_file_name.split(".");
            var mappingData = {
                id: newId,
                docId: v.id,
                docFile: v.original_file_name,
                docFileType: type[type.length - 1],
                docFileData: "",
                docUrl: getFullUrlPath(v.file_path, true)
            };
            return mappingData;
        });
        setAttachments(attchments);
    } else {
        setAttachments([]);
    }
    if (dataWithReplacements.factTagDo && dataWithReplacements.factTagDo.length > 0) {
        var mappingData = dataWithReplacements.factTagDo.map(function(v) {
            return v.name;
        });
        setTagSelected(mappingData);
    } else {
        setTagSelected([]);
    }
    if (dataWithReplacements.dimMstDoStatus && dataWithReplacements.dimMstDoStatus.id > 1) {
        setFormdisabled(true);
    }
    dataWithReplacements.dim_mst_new_status_id = "";
    dataWithReplacements.dim_new_item_so_sorts = [];
    if (dataWithReplacements.factItemSoColSort && dataWithReplacements.factItemSoColSort.length > 0) {
        var mappingCols = dataWithReplacements.factItemSoColSort.map(function(v) {
            return {
                id: v.dimMstItemSoCol.id,
                sortKey: v.dimMstItemSoCol.name
            };
        });
        while(mappingCols.length <= 3){
            mappingCols.push({
                id: "",
                sortKey: ""
            });
        }
        setColumnsort(_object_spread_props(_object_spread({}, columnsort), {
            columnsort: mappingCols
        }));
    }
}
function runMappingPipeline(_param) {
    var pipelineSteps = _param.pipelineSteps, context = _object_without_properties(_param, [
        "pipelineSteps"
    ]);
    pipelineSteps.forEach(function(fn) {
        fn(context);
    });
}
// public
export function mappingMemberDo(param) {
    var id = param.id, customer_id = param.customer_id, full_member_name = param.full_member_name, full_member_address_name = param.full_member_address_name, additional_info = param.additional_info, member_branch_no = param.member_branch_no, member_phone_number = param.member_phone_number;
    return {
        customerID: id,
        customerCode: customer_id,
        customerName: full_member_name,
        customerNameShort: "-",
        branchCode: member_branch_no,
        branchName: additional_info,
        address: full_member_address_name,
        phoneNumber: member_phone_number
    };
}
export function mappingOptionNewItemDoCol(options) {
    return options.filter(function(item) {
        return item.is_active;
    }).map(function(item) {
        var sortKey = "";
        switch(item.name_th){
            case "รหัสสินค้า":
                sortKey = "productCode";
                break;
            case "รายการ":
                sortKey = "productName";
                break;
            case "บาร์โค้ด":
                sortKey = "productBarcode";
                break;
            case "คลังจัดส่ง":
                sortKey = "warehouseName";
                break;
            case "หน่วย":
                sortKey = "productUnit";
                break;
            case "จำนวน":
                sortKey = "productQty";
                break;
            case "ราคา/หน่วย":
                sortKey = "productPrice";
                break;
            case "ประเภทส่วนลด":
                sortKey = "discountType";
                break;
            case "ส่วนลด/หน่วย":
                sortKey = "discount";
                break;
            case "ภาษี":
                sortKey = "vat";
                break;
            case "มูลค่าก่อนภาษี":
                sortKey = "valueBeforeVat";
                break;
            case "มูลค่ารวมภาษี":
                sortKey = "valueIncludingVat";
                break;
            default:
                break;
        }
        return {
            label: item.name_th,
            value: item.id,
            sortKey: sortKey
        };
    });
}
export function mappingDo(param) {
    var soData = param.soData, setProductRow = param.setProductRow, setPdata = param.setPdata, setFormdisabled = param.setFormdisabled, columnsort = param.columnsort, setColumnsort = param.setColumnsort, setAttachments = param.setAttachments, setAttachmentDeliver = param.setAttachmentDeliver, setTagSelected = param.setTagSelected;
    var dataWithReplacements = Object.entries(soData).reduce(function(acc, param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        acc[key] = value === null ? "" : value;
        return acc;
    }, {});
    runMappingPipeline({
        pipelineSteps: pipelineStepsFromDoID,
        setProductRow: setProductRow,
        setFormdisabled: setFormdisabled,
        columnsort: columnsort,
        setColumnsort: setColumnsort,
        setAttachments: setAttachments,
        setAttachmentDeliver: setAttachmentDeliver,
        setTagSelected: setTagSelected,
        setPdata: setPdata,
        dataWithReplacements: dataWithReplacements
    });
    return dataWithReplacements;
}
export var mapProductToRequestItem = function(product, isModalOpen) {
    return product.map(function(v) {
        return {
            fact_new_so_item_id: v.soItemID,
            dim_product_price_id: v.productID,
            dim_warehouse_id: v.warehouseID,
            quantity: v.productQty,
            item_so_quantity: v.item_so_quantity || 0,
            unit_price: v.productPrice,
            unit_id: v.productUnitID,
            ratio_unit: v.productRatioUnit,
            container: v.productContainer,
            dim_mst_discount_type_id: v.discountType,
            discount_value: v.discountType === 1 ? v.discountPercent : v.discount,
            discount_price: v.discount,
            dim_mst_vat_id: v.dim_mst_vat_id,
            remark: v.note,
            maxQty: v.soItemID && !isModalOpen ? v.remainingQty : null
        };
    });
};
export var mapProductToRequestUpdateItem = function(product, isModalOpen) {
    return product.map(function(v) {
        return {
            id: v.doItemID,
            fact_new_so_item_id: v.soItemID,
            dim_product_price_id: v.productID,
            dim_warehouse_id: v.warehouseID,
            quantity: v.productQty,
            item_so_quantity: v.item_so_quantity || 0,
            unit_price: v.productPrice,
            unit_id: v.productUnitID,
            ratio_unit: v.productRatioUnit,
            container: v.productContainer,
            dim_mst_discount_type_id: v.discountType,
            discount_value: v.discountType === 1 ? v.discountPercent : v.discount,
            discount_price: v.discount,
            dim_mst_vat_id: v.dim_mst_vat_id,
            remark: v.note,
            maxQty: v.soItemID && !isModalOpen ? v.remainingQty : null
        };
    });
};
export var jsonKeys = [
    "update_doc_ids",
    "tag_does",
    "fact_new_do_items",
    "update_do_items",
    "doc_files"
];
export var allowedFields = [
    "fact_new_so_id",
    "so_doc_number_ref",
    "dim_mst_do_status_id",
    "dim_mst_payment_type_id",
    "dim_mst_price_category_id",
    "is_ready_to_delivery",
    "doc_issue_date",
    "delivery_date",
    "fact_member_id",
    "dim_warehouse_id",
    "dim_branch_id",
    "refer",
    "dim_mst_discount_type_id",
    "discount_value",
    "discount_price",
    "remark",
    "is_sort_manual",
    "is_delivery_success",
    "undelivered_reason",
    "updated_success_delivery_at",
    "not_approve_reason",
    "fact_item_do_col_sorts",
    "sum_item_so_quantity",
    "is_receive_point",
    "updated_success_delivery_time"
].concat(_to_consumable_array(jsonKeys));
export function getActionDoDisplay(param) {
    var formdisabled = param.formdisabled, dimMstNewStatus = param.dimMstNewStatus, values = param.values;
    var status1 = !formdisabled && (!dimMstNewStatus || dimMstNewStatus && dimMstNewStatus.id < 2 || dimMstNewStatus && dimMstNewStatus.id === 6);
    var status2 = !formdisabled && (!dimMstNewStatus || dimMstNewStatus && dimMstNewStatus.id !== 6);
    var status2_1 = !(dimMstNewStatus && dimMstNewStatus.id > 1);
    var status4 = !!(dimMstNewStatus && dimMstNewStatus.id > 1 && dimMstNewStatus.id < 3);
    var status5 = !!(dimMstNewStatus && dimMstNewStatus.id > 2);
    var statusDropdown4 = !dimMstNewStatus || dimMstNewStatus && dimMstNewStatus.id < 4;
    var statusDropdown4_1 = !(dimMstNewStatus && dimMstNewStatus.id > 1);
    var statusDropdown5 = !!(dimMstNewStatus && dimMstNewStatus.id > 1);
    var statusReadyPickList = !!(dimMstNewStatus && [
        2,
        4
    ].includes(dimMstNewStatus.id));
    var statusReadyDelivery = !!(dimMstNewStatus && [
        2,
        4
    ].includes(dimMstNewStatus.id) && values && values.ready_to_delivery_date);
    var statusReadyฺBtnDelivery = !!(dimMstNewStatus && [
        2
    ].includes(dimMstNewStatus.id) && values && values.ready_to_delivery_date);
    var statusBtnPickList = !!(dimMstNewStatus && values && !values.ready_to_delivery_date && dimMstNewStatus.id === 2);
    var statusCancel = !!(dimMstNewStatus && dimMstNewStatus.id === 2 && values && !values.ready_to_delivery_date);
    var actionDisplay = {
        status1: status1,
        status2: status2,
        status2_1: status2_1,
        status4: status4,
        status5: status5,
        statusDropdown4: statusDropdown4,
        statusDropdown4_1: statusDropdown4_1,
        statusDropdown5: statusDropdown5,
        statusReadyPickList: statusReadyPickList,
        statusReadyDelivery: statusReadyDelivery,
        statusReadyฺBtnDelivery: statusReadyฺBtnDelivery,
        statusBtnPickList: statusBtnPickList,
        statusCancel: statusCancel
    };
    return actionDisplay;
}
export function isDisabledEditDo(param) {
    var dimMstNewStatus = param.dimMstNewStatus;
    var disabledList = [
        4,
        5
    ];
    if (dimMstNewStatus && disabledList.includes(parseInt(dimMstNewStatus.id))) {
        return true;
    }
    return false;
}
export function getDateDoByStatus(param) {
    var values = param.values, label = param.label;
    if (label === "สร้างใบส่งของ" && values.updated_approve_at) {
        return moment(values.updated_approve_at, "YYYY-MM-DD").add(7, "hours").format("DD/MM/YYYY");
    } else if (label === "ยืนยันจัดส่ง" && values.ready_to_delivery_date) {
        return moment(values.ready_to_delivery_date, "YYYY-MM-DD").add(7, "hours").format("DD/MM/YYYY");
    } else if (label === "เสร็จสิ้นDO" && values.dim_mst_do_status_id === 4 && values.updated_success_delivery_at) {
        return moment(values.updated_success_delivery_at, "YYYY-MM-DD").add(7, "hours").format("DD/MM/YYYY");
    }
    return "-";
}
export function loadDocDataFromSoProcess(param) {
    var docSelected = param.docSelected, setProductRow = param.setProductRow, setFormdata = param.setFormdata, setPdata = param.setPdata;
    if (docSelected) {
        var dataWithReplacements = Object.entries(docSelected).reduce(function(acc, param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
            acc[key] = value === null ? "" : value;
            return acc;
        }, {});
        runMappingPipeline({
            pipelineSteps: pipelineStepsFromSoDoc,
            setProductRow: setProductRow,
            setFormdata: setFormdata,
            setPdata: setPdata,
            dataWithReplacements: dataWithReplacements
        });
    }
}
export var getDeliveredStatusList = [
    2
];
// override product select
export var handleRowSelectOverrideDO = function(param) {
    var ids = param.ids, setProductRow = param.setProductRow, filteredItems = param.filteredItems, optionsWarehouse = param.optionsWarehouse, values = param.values;
    var selectedIDs = new Set(ids);
    var selectedRows = filteredItems.filter(function(row) {
        return selectedIDs.has(row.productID);
    });
    if (selectedRows.length > 0) {
        setProductRow(function(productRow) {
            var _selectedRows__dimProduct, _selectedRows__dimProduct1;
            var warehouseID = values.dim_warehouse_id;
            var warehouse = optionsWarehouse.find(function(item) {
                return values.dim_warehouse_id === item.value;
            });
            var warehouseName = warehouse ? warehouse.label : "";
            var vatByMstCatPrice = getVatByMstCategoryPrice(values.dim_mst_price_category_id, selectedRows[selectedRows.length - 1].dim_mst_vat_id, selectedRows[selectedRows.length - 1].vat);
            var lastSelectedRow = _object_spread_props(_object_spread({}, selectedRows[selectedRows.length - 1]), {
                rowID: nanoid(),
                supplierCode: (_selectedRows__dimProduct = selectedRows[selectedRows.length - 1].dimProduct) === null || _selectedRows__dimProduct === void 0 ? void 0 : _selectedRows__dimProduct.supplier_code,
                supplierName: getSupplierProductName((_selectedRows__dimProduct1 = selectedRows[selectedRows.length - 1].dimProduct) === null || _selectedRows__dimProduct1 === void 0 ? void 0 : _selectedRows__dimProduct1.supplier_names),
                warehouseID: warehouseID,
                warehouseName: warehouseName,
                dim_mst_vat_id: vatByMstCatPrice.dim_mst_vat_id,
                vat: vatByMstCatPrice.vat,
                productPrice: 0
            });
            var existingRowIndex = productRow.findIndex(function(row) {
                return !row.productID;
            });
            if (existingRowIndex !== -1) {
                var updatedRows = _to_consumable_array(productRow);
                updatedRows[existingRowIndex] = lastSelectedRow;
                return updatedRows;
            } else {
                return _to_consumable_array(productRow).concat([
                    lastSelectedRow
                ]);
            }
        });
    }
};
export var handleOnSelectProductRowOverrideDO = function(param) {
    var item = param.item, rowID = param.rowID, values = param.values, optionsWarehouse = param.optionsWarehouse, optionsMstVat = param.optionsMstVat, setProductRow = param.setProductRow;
    setProductRow(function(prev) {
        return prev.map(function(el) {
            if (el.rowID === rowID) {
                var _item_dimProduct, _item_dimProduct1;
                var warehouseID = null;
                var warehouseName = null;
                warehouseID = values.dim_warehouse_id;
                var warehouse = optionsWarehouse.find(function(item) {
                    return values.dim_warehouse_id === item.value;
                });
                warehouseName = warehouse ? warehouse.label : "";
                var dim_mst_vat_id = null;
                var vat = 0;
                optionsMstVat.map(function(v) {
                    if (item.dimProduct && item.dimProduct.vat === "ไม่มี VAT" && v.value === 1) {
                        dim_mst_vat_id = v.value;
                        vat = v.vat;
                    }
                    if (item.dimProduct && item.dimProduct.vat === "VAT 0%" && v.value === 2) {
                        dim_mst_vat_id = v.value;
                        vat = v.vat;
                    }
                    if (item.dimProduct && item.dimProduct.vat === "VAT 7%" && v.value === 3) {
                        dim_mst_vat_id = v.value;
                        vat = v.vat;
                    }
                });
                var vatByMstCatPrice = getVatByMstCategoryPrice(values.dim_mst_price_category_id, dim_mst_vat_id, vat);
                return _object_spread_props(_object_spread({}, el), {
                    productCode: item.dimProduct && item.dimProduct.sku ? item.dimProduct.sku : "-",
                    productID: item.id,
                    productName: item.dimProduct && item.dimProduct.name_th ? item.dimProduct.name_th : "-",
                    supplierCode: (_item_dimProduct = item.dimProduct) === null || _item_dimProduct === void 0 ? void 0 : _item_dimProduct.supplier_code,
                    supplierName: getSupplierProductName((_item_dimProduct1 = item.dimProduct) === null || _item_dimProduct1 === void 0 ? void 0 : _item_dimProduct1.supplier_names),
                    productRatioUnit: item.ratio_unit,
                    productContainer: item.container,
                    productBarcode: item.barcode,
                    sellPrice: item.price_1,
                    productPrice: 0,
                    productUnit: item.dimMasterUnit && item.dimMasterUnit.name ? item.dimMasterUnit.name : "-",
                    productUnitID: item.dimMasterUnit && item.dimMasterUnit.id ? item.dimMasterUnit.id : "-",
                    productOrdered: item.productOrdered,
                    ums: item.ums,
                    productStock: item.productStock,
                    warehouseID: warehouseID,
                    warehouseName: warehouseName,
                    discountType: 1,
                    discountPercent: 0,
                    discount: 0,
                    productQty: 1,
                    edit: false,
                    dim_mst_vat_id: vatByMstCatPrice.dim_mst_vat_id,
                    vat: vatByMstCatPrice.vat
                });
            }
            return el;
        });
    });
};
export var isDoOverDue = function(param) {
    var dueDeliveryDate = param.dueDeliveryDate, deliveredSuccess = param.deliveredSuccess, statusID = param.statusID;
    if (statusID !== 2) return false;
    var dueDate = moment(dueDeliveryDate).startOf("day");
    // Case 1: ถ้าส่งของแล้ว
    if (deliveredSuccess) {
        var deliveredDate = moment(deliveredSuccess).startOf("day");
        return deliveredDate.isAfter(dueDate); // ส่งช้าไหม
    }
    // Case 2: ยังไม่ส่ง → เช็คว่าวันนี้เลยวันกำหนดหรือยัง
    var today = moment().startOf("day");
    return today.isAfter(dueDate); // เลยกำหนดส่งไหม
};
